(function () {
  var sections = document.querySelectorAll('[data-recommendations-section]');

  sections.forEach(function (section) {
    var url = section.getAttribute('data-url');
    var target = section.querySelector('[data-recommendations-target]');
    if (!url || !target) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('.product-grid');
        if (grid) {
          target.innerHTML = grid.outerHTML;
        } else {
          section.hidden = true;
        }
      })
      .catch(function () {
        section.hidden = true;
      });
  });
})();
